export const REASON_CODE_KEY_MUST_BE_UNIQUE_MESSAGE =
  "Reason Code Key Already Exists.";

const REASON_CODE_KEY_MAX_LENGTH = 255;
const REASON_CODE_KEY_PATTERN = /^[A-Z0-9]+(-[A-Z0-9]+)*$/;
const REASON_CODE_KEY_FORMAT_MESSAGE =
  "Only uppercase letters, numbers, and hyphens are allowed.";

function getMutationErrorMessage(error: unknown): string {
  return error instanceof Error ? error.message.trim() : "";
}

export function isReasonCodeKeyDuplicateError(error: unknown): boolean {
  const normalized = getMutationErrorMessage(error).toLowerCase();
  return (
    normalized.includes("reason code key") ||
    normalized.includes("must be unique") ||
    normalized.includes("duplicate") ||
    normalized.includes("already exists")
  );
}

export function createReasonCodeKeyRules() {
  return [
    { required: true, message: "Reason code key is required" },
    {
      pattern: REASON_CODE_KEY_PATTERN,
      message: REASON_CODE_KEY_FORMAT_MESSAGE,
    },
    {
      max: REASON_CODE_KEY_MAX_LENGTH,
      message: `Reason code key must be less than or equal to ${REASON_CODE_KEY_MAX_LENGTH} characters.`,
    },
  ];
}
